import LogoDark from "../../assets/img/skorLogo.svg";
import LogoLight from "../../assets/img/logo.svg";
import useTranslator from "../../hooks/useTranslator";
import "./PoweredBySkor.css";

// Small "Powered by Skor" attribution shown instead of the full-size Skor
// logo inside embedded (SDK iframe) surfaces, where the host portal's own
// branding leads and Skor stays present but not prominent.
// tone="dark": dark wordmark for light surfaces (default).
// tone="light": light wordmark for dark surfaces (e.g. onboarding rail).
const PoweredBySkor = ({ tone = "dark" }) => {
  const { _t } = useTranslator();
  const light = tone === "light";
  return (
    <span
      className={`powered-by-skor powered-by-skor--${light ? "light" : "dark"}`}
    >
      <span className="powered-by-skor__text">
        {_t("poweredBy", "Powered by")}
      </span>
      <img
        className="powered-by-skor__logo"
        src={light ? LogoLight : LogoDark}
        alt="Skor"
      />
    </span>
  );
};

export default PoweredBySkor;
